import { createContext, useContext } from 'react'

export const SearchContext = createContext<{ openSearch: () => void; isOpen: boolean } | null>(null)
export function useUniversalSearch() {
  return useContext(SearchContext)
}
